(function () {
  const COMPANY_ID = window.KLAVIYO_PUBLIC_KEY;
  const LIST_ID    = window.KLAVIYO_BIS_LIST_ID;   // ID конкретного List в Klaviyo
  const REVISION   = '2024-10-15';
  const BASE       = 'https://a.klaviyo.com/client';

  if (!COMPANY_ID || !LIST_ID) { console.warn('[BIS] Klaviyo config missing'); return; }

  const modal = document.querySelector('[data-bis-modal]');
  if (!modal) return;
  // Waitlist-режим: заявку обробляє нативна Shopify contact-форма, Klaviyo не потрібен
  if (modal.dataset.bisMode === 'waitlist') {
    const wlForm = modal.querySelector('[data-bis-wl-form]');
    const wlBody = modal.querySelector('[data-bis-wl-body]');
    const wlVariantInput = modal.querySelector('[data-bis-variant-input]');

    // Open
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-bis-open]');
      if (!trigger) return;
      const wrap = trigger.closest('[data-bis-wrapper]');
      if (wrap?.dataset.variantId && wlVariantInput) wlVariantInput.value = wrap.dataset.variantId;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    });

    // Close
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-bis-close]') || e.target === modal) modal.close?.();
    });

    // Sync variant on PDP
    document.addEventListener('change', () => {
      const currentInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const wrap = document.querySelector('[data-bis-wrapper]');
      if (currentInput && wrap && wlVariantInput) {
        wrap.dataset.variantId = currentInput.value;
        wlVariantInput.value = currentInput.value;
      }
    });

    // Заповнюємо тіло листа перед відправкою
    if (wlForm && wlBody) {
      wlForm.addEventListener('submit', () => {
        const name  = wlForm.querySelector('[name="contact[name]"]')?.value.trim() || '';
        const email = wlForm.querySelector('[name="contact[email]"]')?.value.trim() || '';
        const phone = wlForm.querySelector('[name="contact[phone]"]')?.value.trim() || '';
        const productTitle = modal.querySelector('.bis-modal__pname')?.textContent.trim() || '';
        const variantTitle = modal.querySelector('[data-bis-variant-title]')?.textContent.trim() || '';
        const variantId    = wlVariantInput?.value || '';

        wlBody.value = [
          'Заявка з листа очікування (waitlist):',
          'Товар: ' + productTitle,
          'Варіант: ' + variantTitle,
          'Variant ID: ' + variantId,
          'Email: ' + email
        ].join('\n');

        // форма сабмітиться нативно на /contact
      }, { passive: true });
    }

    return; // Klaviyo-логіку нижче не виконуємо
  }
  const form         = modal.querySelector('[data-bis-form]');
  const variantInput = modal.querySelector('[data-bis-variant-input]');
  const errorEl      = modal.querySelector('[data-bis-error]');
  const formState    = modal.querySelector('[data-bis-form-state]');
  const successState = modal.querySelector('[data-bis-success-state]');
  const submitBtn    = form.querySelector('button[type="submit"]');

  // Open
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-bis-open]');
    if (!trigger) return;
    const wrap = trigger.closest('[data-bis-wrapper]');
    if (wrap?.dataset.variantId) variantInput.value = wrap.dataset.variantId;
    reset();
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
  });

  // Close
  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-bis-close]') || e.target === modal) modal.close?.();
  });

  // Sync variant on PDP
  document.addEventListener('change', () => {
    const currentInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const wrap = document.querySelector('[data-bis-wrapper]');
    if (currentInput && wrap) {
      wrap.dataset.variantId = currentInput.value;
      variantInput.value = currentInput.value;
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;
    submitBtn.disabled = true;

    const email = form.email.value.trim();
    const variantId = variantInput.value;
    const productTitle = modal.querySelector('.bis-modal__pname')?.textContent.trim() || '';
    const variantTitle = modal.querySelector('[data-bis-variant-title]')?.textContent.trim() || '';

    try {
      // 1) Підписуємо профіль в окремий List (тут прибрано проблемне поле subscriptions)
      const subRes = await fetch(`${BASE}/subscriptions/?company_id=${COMPANY_ID}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Back in Stock Form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: LIST_ID } }
            }
          }
        })
      });

      if (!(subRes.status === 202 || subRes.ok)) {
        const d = await subRes.json().catch(() => ({}));
        throw new Error(d?.errors?.[0]?.detail || 'Не вдалося підписати email.');
      }

      // 2) Реєструємо catalog back-in-stock subscription (тригер для Flow)
      const bisRes = await fetch(`${BASE}/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` }
              }
            }
          }
        })
      });

      if (!(bisRes.status === 202 || bisRes.ok)) {
        const d = await bisRes.json().catch(() => ({}));
        throw new Error(d?.errors?.[0]?.detail || 'Не вдалося зареєструвати підписку на товар.');
      }

      // 3) (Опціонально) кастомний event для аналітики/сегментів
      fetch(`${BASE}/events/?company_id=${COMPANY_ID}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                ProductTitle: productTitle,
                VariantTitle: variantTitle,
                VariantID: variantId
              },
              metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Requested' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      }).catch(() => {});

      formState.hidden = true;
      successState.hidden = false;
      window.dataLayer?.push({ event: 'back_in_stock_subscribed', variant_id: variantId, product_title: productTitle });

    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
    } finally {
      submitBtn.disabled = false;
    }
  });

  function reset() {
    formState.hidden = false;
    successState.hidden = true;
    errorEl.hidden = true;
    form.reset();
  }
})();